/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GlycemicAdministrationAliases {
  ACCORDION_CONTENT_PANEL = 'accordion-content-panel',
  ACCORDION_HEADER_PANEL = 'accordion-header-panel',
  AUTOCOMPLETE = 'autocomplete',
  BODY_BARCODE_PANEL = 'body-barcode-panel',
  BODY_MEDICATION_PANEL = 'body-medication-panel',
  BODY_PANEL = 'body-panel',
  CONTENT_FORM = 'content-form',
  EVENT_DATE_FIELD = 'event-date-field',
  EVENT_DATE_INPUT = 'event-date-input',
  FETCH_APPLICATION_SITES = 'fetch-application-sites',
  FIELD_APPLICATION_SITES = 'field-application-sites',
  FOOTER_ACTIONS = 'footer-actions',
  FOOTER_PANEL = 'footer-panel',
  GLOBAL_ACTIONS_PANEL = 'global-actions-panel',
  GLYCEMIC_ADMINISTRATION_LAYOUT = 'glycemic-administration-layout',
  GLYCEMIC_BARCODE = 'glycemic-barcode',
  GLYCEMIC_LEVEL_FIELD = 'glycemic-level-field',
  GLYCEMIC_LEVEL_INPUT = 'glycemic-level-input',
  GLYCEMIC_MEDICATION_DETAILS_CARD = 'glycemic-medication-details-card',
  GLYCEMIC_SCHEDULE_DATE = 'glycemic-schedule-date',
  GLYCEMIC_SCHEDULE_DATE_FIELD = 'glycemic-schedule-date-field',
  GLYCEMIC_TITLE = 'glycemic-title',
  GLYCEMIC_TITLE_FIELD = 'glycemic-title-field',
  HEADER_PANEL = 'header-panel',
  INFORMATION_ACCORDION = 'information-accordion',
  INFORMATION_HEADER_TEXT = 'information-header-text',
  INFORMATION_MEDICATION_ACCORDION = 'information-medication-accordion',
  JUSTIFICATION_FIELD = 'justification-field',
  JUSTIFICATION_TEXT_AREA = 'justification-text-area',
  LEGENDS_ADMINISTRATION = 'legends-administration',
  LOADER = 'loader',
  LOADING_PANEL = 'loading-panel',
  MAPPER_TEXT = 'mapper-text',
  MEDICATION_ACCORDION_HEADER_PANEL = 'medication-accordion-header-panel',
  MEDICATION_DECK = 'medication-deck',
  MEDICATION_INFORMATION_HEADER_TEXT = 'medication-information-header-text',
  MEDICATIONS_PANEL = 'medications-panel',
  NEXT_BUTTON = 'next-button',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  SUGGESTION_FIELD = 'suggestion-field',
  SUGGESTION_TEXT_AREA = 'suggestion-text-area',
  TEXT_APPLICATION = 'text-application',
  VARIATION_AUTOCOMPLETE = 'variation-autocomplete',
  VARIATION_FIELD = 'variation-field',
  VARIATION_MAPPER = 'variation-mapper',
  VARIATION_TEXT = 'variation-text',
}
export { GlycemicAdministrationAliases };
